export default __webpack_public_path__ + "static/2_31-3af27edfb800bf912d136142569023fc.png";